/** Shared date filter state for template lists (Send Email, Email Design, etc.). */
export type TemplateDatePreset =
  | "all"
  | "today"
  | "last-3-days"
  | "last-7-days"
  | "last-week"
  | "last-month"
  | "current-year"
  | "year-2025"
  | "year-2024"
  | "year-2023"
  | "year-2022"
  | "custom";

export type TemplateDateFilterValue = {
  templateDatePreset: TemplateDatePreset;
  /** `YYYY-MM-DD` when preset is `custom`. */
  templateDateFrom: string;
  templateDateTo: string;
};

export const DEFAULT_TEMPLATE_DATE_FILTER: TemplateDateFilterValue = {
  templateDatePreset: "all",
  templateDateFrom: "",
  templateDateTo: "",
};
